import { BlockStack, Box, Link, Text } from '@shopify/polaris'

import { PartnerAppKey, partnerApps } from './partnersData'
import styles from './PartnersPage.module.css'

export const PartnerCard = ({ appKey }: { appKey: PartnerAppKey }) => (
  <Box
    minHeight="100%"
    borderWidth="025"
    borderColor="border"
    background="bg-fill"
    borderRadius="200"
    position="relative"
  >
    <Box padding="400" paddingBlockEnd="1200">
      <BlockStack gap="300">
        <img
          className={styles.icon}
          src={partnerApps[appKey].icon}
          alt={partnerApps[appKey].name}
          width={48}
          height={48}
        />
        <Text variant="headingMd" as="h3">
          {partnerApps[appKey].name}
        </Text>
        <Text as="p" tone="subdued">
          {partnerApps[appKey].description}
        </Text>
      </BlockStack>
    </Box>
    <Box position="absolute" insetBlockEnd="0" padding="400" paddingBlockStart="0">
      <Link url={partnerApps[appKey].url} external>
        Learn More
      </Link>
    </Box>
  </Box>
)
